import { render, staticRenderFns } from "./EventiNoSync.vue?vue&type=template&id=644f324d&"
import script from "./EventiNoSync.vue?vue&type=script&lang=js&"
export * from "./EventiNoSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports